export enum PreviewGridType {
  Row = 'col-1',
  TwoColumns = 'col-2',
  FourColumns = 'col-4',
}
